import { fontList } from '../../core/font-list';
import { colorListPairs, colorMap, colorListCharts } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 60,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 80,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 110,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'backgroundColorSlide1': {
      'default': '#329B46',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'logoWidth': {
      'default': 55,
      'label': 'logoWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoX': {
      'default': 50,
      'label': 'logoX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoY': {
      'default': 545,
      'label': 'logoY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoColor': {
      'default': '#222222',
      'label': 'logoColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'topTextSlide1X': {
      'default': 300,
      'label': 'topTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'topTextSlide1Y': {
      'default': 40,
      'label': 'topTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'topTextSlide1': {
      'default': 'Under 2017 ökade befolkningen\ni tätorter med nästan',
      'label': 'topTextSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'topTextSlide1FontSize': {
      'default': 60,
      'label': 'topTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'topTextSlide1LineHeight': {
      'default': 1.2,
      'label': 'topTextSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'topTextSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'topTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'topTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'topTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'topTextSlide1Anchor': {
      'default': 'middle',
      'label': 'topTextSlide1Anchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'centerTextSlide1X': {
      'default': 300,
      'label': 'centerTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'centerTextSlide1Y': {
      'default': 380,
      'label': 'centerTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'centerTextSlide1': {
      'default': '100 000',
      'label': 'centerTextSlide1',
      'type': 'string',
      'control': 'standard-control',
    },
    'centerTextSlide1FontSize': {
      'default': 200,
      'label': 'centerTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'centerTextSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'centerTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'centerTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'centerTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'centerTextSlide1Anchor': {
      'default': 'middle',
      'label': 'centerTextSlide1Anchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'bottomTextSlide1X': {
      'default': 300,
      'label': 'bottomTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'bottomTextSlide1Y': {
      'default': 460,
      'label': 'bottomTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'bottomTextSlide1': {
      'default': 'Källa: Folkmängd och landareal i tätorter,\nper tätort 2017, SCB',
      'label': 'bottomTextSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'bottomTextSlide1FontSize': {
      'default': 24,
      'label': 'bottomTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bottomTextSlide1LineHeight': {
      'default': 1.2,
      'label': 'bottomTextSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bottomTextSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'bottomTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'bottomTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'bottomTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'bottomTextSlide1TextAnchor': {
      'default': 'middle',
      'label': 'bottomTextSlide1TextAnchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'backgroundColorSlide2': {
      'default': '#64CDFA',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'bannerColorSlide2': {
      'default': '#0AAFEB',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2': {
      'default': '8,8 miljoner i en tätort',
      'label': 'titleTextSlide2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2X': {
      'default': 300,
      'label': 'titleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2Y': {
      'default': 74,
      'label': 'titleTextSlide2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2FontSize': {
      'default': 60,
      'label': 'titleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'titleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line1': {
      'default': 'vid utgången av 2017',
      'label': 'subtitleTextSlide2Line1',
      'type': 'string',
      'control': 'standard-control',
    },
    // 'subtitleTextSlide2Line2': {
    //   'default': 'bla bla',
    //   'label': 'subtitleTextSlide2Line2',
    //   'type': 'string',
    //   'control': 'standard-control',
    // },
    'subtitleTextSlide2X': {
      'default': 300,
      'label': 'subtitleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line1Y': {
      'default': 110,
      'label': 'subtitleTextSlide2Line1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line2Y': {
      'default': 110,
      'label': 'subtitleTextSlide2Line2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontSize': {
      'default': 24,
      'label': 'subtitleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'subtitleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'subtitleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'bannerHeight': {
      'default': 133,
      'label': 'bannerHeight',
      'type': 'string',
      'control': 'standard-number',
    },
    'minY': {
      'default': 0,
      'label': 'minY',
      'type': 'string',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 10000000,
      'label': 'maxY',
      'type': 'string',
      'control': 'standard-number',
    },
    'steps': {
      'default': 4,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitText': {
      'default': '',
      'label': 'unitText',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitFontFamily': {
      'default': 'Steelfish',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'unitTextOffsetY',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 100,
      'label': 'labelSpaceY',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'labelSpaceX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#FFFFFF',
      'label': 'labelColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 32,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontWeight': {
      // 'default': 'normal',
      'default': 'bold',
      'label': 'labelFontWeight',
      'type': 'string',
      'control': 'standard-number',
    },
    'xAxisLabelFontSize': {
      'default': 32,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      // 'default': 'Poly Regular',
      'default': 'Steelfish',
      'label': 'labelFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontAnchor': {
      'default': 'start',
      'label': 'labelFontAnchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'labelOffsetY',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'labelOffsetX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'labelDecimalsY',
      'type': 'number',
      'control': 'standard-number',
    },
    'leftLabelX': {
      'default': '1960',
      'label': 'leftLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2017',
      'label': 'rightLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#979797',
      'label': 'axisStroke',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 1,
      'label': 'axisStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': ['#C86EC8'],
      'label': 'lineStrokes',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'lineStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Miter'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Miter'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Round'
        }
      ],
      'control': 'standard-select',
    },
    'formatLocale': {
      'default': {
        'key': 'fi',
        'value': 'fi',
        'label': 'Suomen kieli'
      },
      'label': 'Taal',
      'type': 'string',
      'values': [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        },
        {
          'key': 'fi',
          'value': 'fi',
          'label': 'Suomen kieli'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
    'backgroundColorSlide3': {
      'default': '#FE8C67',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
  },
  'timings': {
    'pauseSlides': {
      'default': 3,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 1,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['Tätorter'], [5451156], [6011673], [6574933], [6789432], [6913493], [7162615], [7417685], [7464637], [7632783], [8015797], [8572514], [8696023], [8795471]],
    'columnLimitMin': 1,
    'columnLimitMax': 4,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 1000,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'backgroundColorSlide1', 'topTextSlide1', 'topTextSlide1FontSize', 'centerTextSlide1', 'centerTextSlide1FontSize', 'bottomTextSlide1', 'bottomTextSlide1FontSize', 'backgroundColorSlide2', 'bannerColorSlide2', 'subtitleTextSlide2Line1', 'minY', 'maxY', 'steps', 'unitText', 'labelDecimalsY'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': [],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': ['pauseSlides', 'slide1Animation', 'slide2Animation', 'pauseEnd']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-scb-triptych-line-hor-steps/social.params.ts